{
  "a11y": {
    "home": "Miami To-Do — inicio",
    "menu": "Menú",
    "closeMenu": "Cerrar menú",
    "search": "Buscar",
    "language": "Idioma: {{name}}",
    "mainNav": "Principal",
    "categories": "Categorías",
    "open": "Abrir {{title}}",
    "breadcrumb": "Ruta de navegación",
    "saved": "Guardados",
    "account": "Cuenta",
    "save": "Guardar {{title}}"
  },
  "nav": {
    "tours": "Tours",
    "boats": "Yates y barcos",
    "everglades": "Everglades",
    "attractions": "Atracciones",
    "dayTrips": "Excursiones",
    "home": "Inicio"
  },
  "home": {
    "metaTitle": "Qué hacer en Miami: tours, paseos en barco y los Everglades",
    "metaDescription": "Qué hacer en Miami: paseos en barco por la bahía de Biscayne, hidrodeslizadores en los Everglades, el art déco de South Beach, el arte urbano de Wynwood y excursiones a Key West.",
    "heroEyebrow": "Tu guía de Miami",
    "heroTitle": "Haz de cada día algo extraordinario.",
    "heroLead": "Los mejores tours, paseos en barco y experiencias de Miami, en un solo lugar.",
    "heroAlt": "Rascacielos del centro de Miami sobre la bahía de Biscayne, con un yate y palmeras",
    "featuredTitle": "Destacados de la semana",
    "featuredEyebrow": "Lo mejor de Miami ahora mismo",
    "viewAllExperiences": "Ver todas las experiencias",
    "moodTitle": "Según tu estado de ánimo",
    "moodEyebrow": "Ideas seleccionadas para cada ocasión",
    "viewAllCategories": "Ver todas las categorías",
    "guideTitle": "Qué hacer en Miami por categoría",
    "guideCount_one": "{{count}} experiencia",
    "guideCount_other": "{{count}} experiencias",
    "guide": {
      "boats": {
        "text": "La bahía de Biscayne desde el agua: cruceros con vistas al skyline y a las mansiones de famosos de Millionaire's Row y Star Island, cruceros al atardecer con champán y party boats con bebidas. Los barcos y yates privados con capitán, casi siempre para 12 o 13 personas, van al sandbar de Haulover o a Raccoon Island para nadar; algunos incluyen jet skis o banana boat.",
        "link": "Ver paseos en barco"
      },
      "everglades": {
        "text": "Los humedales empiezan a menos de una hora al oeste de la ciudad. La mayoría de las salidas son paseos en airboat entre los pastizales, buscando caimanes y aves: una hora en un bote privado o semiprivado, o medio día con traslado desde el hotel, un show de fauna o una caminata en el Parque Nacional Everglades. Algunos tours combinan el airboat con un crucero por la bahía de Biscayne y un recorrido por la ciudad.",
        "link": "Ver tours a los Everglades"
      },
      "city-tours": {
        "text": "Los barrios de Miami en carrito de golf, buggy, Segway, bici, bus descapotable o a pie: los murales de Wynwood, los hoteles Art Deco y el neón de South Beach, los cafés de la Pequeña Habana. Los tours tres en uno recorren los tres en medio día; otros se centran en el arte urbano, la comida, los lugares de rodaje o Coral Gables.",
        "link": "Ver tours por la ciudad"
      },
      "day-trips": {
        "text": "Días completos fuera de Miami con transporte: por la Overseas Highway, pasando por Key Largo e Islamorada, hasta Key West; al norte, al Kennedy Space Center; o a Fort Lauderdale y Palm Beach con el Museo Flagler. Hay vans en grupo reducido y también choferes privados.",
        "link": "Ver excursiones de un día"
      },
      "water-sports": {
        "text": "La bahía de Biscayne es el escenario: tours guiados en jet ski frente al skyline y Star Island, yates que incluyen jet skis, banana boat y tubing, wakesurf, clases de esquí acuático y jet cars. Muchas salidas parten de marinas de Miami Beach; revisa qué incluye cada una antes de reservar, porque las tarifas varían.",
        "link": "Ver deportes acuáticos"
      },
      "attractions": {
        "text": "Entradas a los museos y lugares de Miami: el arte inmersivo de Superblue, los Wynwood Walls, el Pérez Art Museum Miami, el Museo y Jardines Vizcaya, el museo de ciencias Frost, el Zoo Miami y Jungle Island. Los pases de la ciudad reúnen varios en una sola entrada.",
        "link": "Ver atracciones"
      },
      "family": {
        "text": "Planes que funcionan para niños y adultos: el Zoo Miami, los encuentros con animales de Jungle Island, el museo de ciencias Frost con su acuario y planetario, y el Museum of Ice Cream. Un Explorer Pass incluye varias atracciones en una sola entrada.",
        "link": "Ver planes en familia"
      }
    }
  },
  "search": {
    "label": "¿Dónde en Miami?",
    "placeholder": "¿Dónde en Miami?",
    "submit": "Buscar",
    "landmark": "Buscar en Miami To-Do",
    "searchFor": "Buscar «{{query}}»",
    "categories": "Categorías",
    "popularTitle": "Búsquedas populares",
    "suggestions": "Sugerencias",
    "popular": [
      { "label": "Hidrodeslizador", "q": "airboat" },
      { "label": "Key West", "q": "key west" },
      { "label": "Crucero por Biscayne", "q": "biscayne" },
      { "label": "South Beach", "q": "south beach" },
      { "label": "Art déco", "q": "art deco" },
      { "label": "Wynwood Walls", "q": "wynwood" },
      { "label": "Little Havana", "q": "little havana" },
      { "label": "Moto acuática", "q": "jet ski" }
    ]
  },
  "mood": {
    "family": "En familia"
  },
  "collections": {
    "tours": {
      "seoTitle": "Tours en Miami: paseos en barco, Everglades y Key West",
      "heading": "Tours y excursiones en Miami",
      "intro": "Todos los tours y experiencias de Miami que recomendamos, los mejor valorados primero.",
      "meta": "Todos los tours de Miami según sus reseñas: paseos en barco por la bahía de Biscayne, yates privados, airboats en los Everglades, art déco, Wynwood y Key West.",
      "guideTitle": "Cómo elegir un tour en Miami",
      "guide": [
        {
          "h": "Qué tipos de tours hay",
          "p": [
            "La mayoría de los tours de Miami son en el agua. Los cruceros panorámicos salen de Bayside Marketplace, en el centro, para una hora más o menos por la bahía de Biscayne, frente a las mansiones de Star Island y Millionaire's Row, el puerto de cruceros y los rascacielos. Los barcos privados con capitán llevan a tu grupo de dos a cuatro horas —a nadar en un banco de arena, a fondear junto a una isla tranquila o a ver el atardecer frente a Brickell—, y el resto de la bahía lo completan los tours en moto acuática (jet ski), los party boats y la pesca deportiva.",
            "Tierra adentro, los Everglades empiezan a menos de una hora al oeste de la ciudad: los paseos en airboat (hidrodeslizador) recorren los pastizales en busca de caimanes y aves, desde un paseo de una hora hasta media jornada con transporte y una parada en el parque nacional. En la ciudad, los tours a pie, en carrito de golf o en Segway recorren el distrito art déco de South Beach, los murales de Wynwood y los cafés y torcedores de tabaco de la Calle Ocho, en Little Havana, y los vuelos en helicóptero o avioneta muestran Miami Beach desde el aire. Las excursiones de un día bajan por la Overseas Highway hasta Key West o suben hacia Fort Lauderdale, Palm Beach y el Centro Espacial Kennedy."
          ]
        },
        {
          "h": "Cómo organizar tus días en Miami",
          "p": [
            "Organízate según el calor y el clima. Las mañanas son el momento más tranquilo en el agua y el más fresco para los airboats y los recorridos a pie; en verano las tormentas suelen formarse por la tarde, así que reserva temprano el barco o los Everglades y deja la tarde para un museo o un crucero al atardecer, cuando ya haya pasado la lluvia. Las noches son para el skyline: cruceros al atardecer, el neón de Ocean Drive y una cena en Brickell o Wynwood.",
            "Tres días alcanzan para lo esencial: un día en Miami Beach con el distrito art déco y un paseo en bote por la bahía, otro para Wynwood y Little Havana, y una mañana en los Everglades. Suma un día largo para Key West —unas cuatro horas de camino en cada sentido— o un día tranquilo de playa. La temporada seca, de noviembre a abril, es la más agradable y la más concurrida, con precios y multitudes al máximo en Navidad, en Art Basel a principios de diciembre y en las vacaciones de primavera de marzo; la temporada de huracanes va de junio a noviembre."
          ]
        },
        {
          "h": "¿Compartido, en grupo reducido o privado?",
          "p": [
            "Los cruceros compartidos y los tours en autobús son la opción más económica, desde unos 25–30 dólares por persona. Los tours en grupo reducido limitan el número de personas —un carrito de golf en Wynwood, un airboat semiprivado, una van a Key West con una docena de viajeros— para tener un guía más cercano a un precio moderado. Los tours privados, una buena parte de esta lista, cuestan más pero son solo para tu grupo: un barco con su capitán para hasta una docena de personas, un airboat o un auto con guía.",
            "En un barco privado el precio suele ser por todo el grupo y no por persona, así que conviene cuando viajan juntos; revisa cuántas personas admite, si incluye combustible, bebidas y juguetes acuáticos, y de qué marina sale: Miami Beach, Bayside, Haulover o más al norte por la costa. Los tours a los Everglades te esperan en el parque de airboats o incluyen transporte desde Miami; la ficha dice cuál. En Estados Unidos se acostumbra dejar propina al capitán o al guía, por lo general un 15–20 % en los tours privados, y a menudo no está incluida en el precio."
          ]
        },
        {
          "h": "Cómo funciona esta lista",
          "p": [
            "Esta página reúne todos los tours y experiencias que tenemos en Miami, ordenados por sus reseñas: un tour con cientos de buenas opiniones va antes que uno con nota perfecta de solo unos pocos viajeros. Abre una categoría para ver una lista más corta.",
            "Reservas en el sitio de nuestro socio, Viator, donde ves el precio actualizado en dólares, las fechas disponibles y la política de cancelación antes de pagar. Muchas experiencias se pueden cancelar gratis hasta 24 horas antes del inicio, y la mayoría de los paseos en barco y en airboat ofrecen otra fecha o el reembolso si el mal tiempo los cancela."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Cuáles son los mejores tours en Miami?",
          "a": "Los tours mejor valorados por los viajeros son un paseo privado en barco por la bahía de Biscayne con parada en un banco de arena, un paseo en airboat por los Everglades, el recorrido a pie por el art déco de South Beach, un tour en carrito de golf por los murales de Wynwood y un crucero al atardecer frente a Star Island y los rascacielos. Esta lista pone primero los tours con las mejores reseñas."
        },
        {
          "q": "¿A qué distancia están los Everglades de Miami?",
          "a": "Los parques de airboats de la Tamiami Trail y de Homestead están a entre 40 minutos y una hora en auto del centro de Miami y de Miami Beach. El paseo dura de 30 a 90 minutos; con transporte desde Miami, calcula de cuatro a seis horas."
        },
        {
          "q": "¿Se puede ir de Miami a Key West en un día?",
          "a": "Sí, pero es un día largo: Key West está a unos 260 km, unas cuatro horas por la Overseas Highway en cada sentido, así que los tours salen temprano y regresan de noche, con unas horas libres en la isla. La mayoría hace paradas en los Cayos de Florida por el camino."
        },
        {
          "q": "¿Cuánto cuesta un paseo en barco en Miami?",
          "a": "Un crucero panorámico compartido por la bahía de Biscayne cuesta desde unos 25–30 dólares por persona. Un barco privado con capitán, desde unos 175–250 dólares por dos a cuatro horas para todo el grupo; los yates más grandes, con tripulación y juguetes acuáticos, van de varios cientos a algunos miles de dólares. Cada tarjeta muestra el precio desde; el sitio del socio muestra el precio exacto para tu fecha y tu grupo."
        },
        {
          "q": "¿Cuándo conviene reservar tours en Miami?",
          "a": "La temporada seca, de noviembre a abril, tiene el clima más agradable y el agua más tranquila; también es la más concurrida, así que reserva con unos días de anticipación para fines de semana, fiestas y las vacaciones de primavera. De junio a noviembre hace calor y humedad, con tormentas por la tarde: elige tours por la mañana y revisa la política por mal tiempo antes de reservar un barco."
        },
        {
          "q": "¿Hay tours en español en Miami?",
          "a": "Sí, muchos: en Miami se habla mucho español, y buena parte de los tours de esta lista se ofrecen en inglés y en español. Los idiomas de cada tour aparecen en su ficha en el sitio del socio."
        }
      ]
    },
    "boats": {
      "title": "Yates y barcos",
      "short": "Barcos\ny cruceros",
      "seoTitle": "Paseos en barco en Miami: Star Island y Millionaire's Row",
      "heading": "Paseos en barco y cruceros por la bahía en Miami",
      "intro": "Cruceros por la bahía de Biscayne junto a Millionaire's Row y Star Island, paseos privados con capitán, navegaciones al atardecer y barcos de fiesta.",
      "meta": "Paseos en barco en Miami: cruceros por la bahía de Biscayne junto a Star Island y Millionaire's Row, paseos privados con capitán, cruceros al atardecer y de fiesta.",
      "partnerTitle": "¿Prefieres un barco solo para tu grupo?",
      "partnerText": "Los tours de arriba se reservan al instante. Para elegir entre más barcos y yates privados —por tamaño, marina y número de invitados—, Sailo tiene cientos en Miami, Miami Beach y Key Biscayne.",
      "guideTitle": "Cómo elegir un paseo en barco en Miami",
      "guide": [
        {
          "h": "¿Crucero compartido o barco privado?",
          "p": [
            "La forma más económica de salir al agua es un crucero panorámico compartido desde Bayside Marketplace, en el centro: unos 90 minutos por la bahía de Biscayne frente al puerto de cruceros, Fisher Island y las mansiones de Star Island y Millionaire's Row, con un guía que va contando de quién es cada casa. Los cruceros al atardecer y con champán hacen una ruta parecida por la tarde, y los party boats suman música y barra libre.",
            "Un barco privado con capitán se reserva solo para tu grupo, normalmente de dos a seis horas y hasta 12 o 13 personas. Tú eliges el plan: los rascacielos y las casas de famosos, un baño en un sandbar, comer a bordo o ver el atardecer frente a Brickell. El precio es por todo el barco, así que para un grupo de seis o más suele salir más barato por persona de lo que parece."
          ]
        },
        {
          "h": "Paradas para nadar y juguetes acuáticos",
          "p": [
            "La mayoría de los barcos privados para a nadar en el camino: en uno de los sandbars de la bahía, donde el agua clara llega a la cintura, o frente a Raccoon Island, más tranquila, con aves y un paseo corto por la isla. Para los sandbars en sí —Haulover o Nixon, mareas y fines de semana— mira Tours al sandbar.",
            "Muchos yates incluyen motos acuáticas, banana, tablas de paddle surf o una colchoneta flotante, a veces en el precio y a veces como extra. Lee qué cubre la tarifa: el combustible, el capitán, las bebidas, el hielo y los juguetes cambian de un barco a otro, y la propina del capitán (lo habitual es un 15–20 %) casi nunca está incluida."
          ]
        },
        {
          "h": "Cuándo ir y qué llevar",
          "p": [
            "Por la mañana el agua suele estar más tranquila. En verano las tormentas de la tarde se forman rápido, así que el capitán puede acortar o cambiar la salida; la mayoría de los tours ofrecen otra fecha o el reembolso si el clima la cancela. De noviembre a abril la bahía está en su mejor momento y los barcos se agotan los fines de semana y en las fiestas.",
            "Lleva protector solar apto para arrecifes, gorra, toalla y el traje de baño puesto, y fíjate en la marina: los barcos salen de Miami Beach, Bayside, el río Miami y Haulover. La lista está ordenada por reseñas, así que primero aparecen los barcos con las valoraciones más constantes."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Cuánto cuesta un paseo privado en barco en Miami?",
          "a": "Un barco pequeño con capitán empieza en unos $175–250 por dos a cuatro horas, para todo el grupo. Los yates más grandes, de 45 a 70 pies, con tripulación y motos acuáticas, cuestan desde unos cientos hasta varios miles de dólares según el tamaño, la duración y el día."
        },
        {
          "q": "¿Quién maneja el barco en un paseo privado?",
          "a": "Un capitán con licencia: todos los barcos de esta lista llevan uno, así que puedes relajarte, bañarte y tomar algo a bordo. Manejar una moto acuática tú mismo es otra cosa: mira la página de deportes acuáticos."
        },
        {
          "q": "¿Podemos llevar comida y bebida?",
          "a": "En la mayoría de los barcos privados, sí: puedes llevar picoteo, bebidas y hasta un pastel para una celebración, y a menudo te dan hielo y nevera. Las botellas de vidrio no suelen estar permitidas. En los cruceros compartidos las bebidas se compran a bordo."
        },
        {
          "q": "¿Qué paseo en barco pasa por las casas de los famosos?",
          "a": "Los cruceros compartidos de Millionaire's Row y Star Island desde Bayside Marketplace giran en torno a ellas, con explicaciones sobre sus dueños. La mayoría de los barcos privados también pasan por Star Island si lo pides."
        }
      ]
    },
    "yacht-rental": {
      "title": "Alquiler de yates",
      "short": "Alquiler\nde yates",
      "intro": "Yates privados con capitán para tu grupo: el skyline, Star Island y el sandbar en la bahía de Biscayne, muchos con jet skis a bordo.",
      "seoTitle": "Alquiler de yates en Miami: privados y con capitán",
      "heading": "Alquiler de yates en Miami",
      "meta": "Alquila un yate privado en Miami con capitán: yates para hasta 13 invitados por la bahía de Biscayne, Star Island y el sandbar, con jet skis y salidas al atardecer.",
      "partnerTitle": "Más yates en Sailo",
      "partnerText": "Sailo tiene cientos de yates a motor en alquiler en Miami, desde cruceros de 40 pies hasta superyates con tripulación completa. Filtra por tamaño, invitados y marina, y reserva en su sitio.",
      "guideTitle": "Cómo alquilar un yate en Miami",
      "guide": [
        {
          "h": "Qué incluye el alquiler",
          "p": [
            "Alquilar un yate en Miami es tener un barco privado para tu grupo con un capitán con licencia, normalmente de tres a ocho horas. El capitán maneja, ancla y arma la ruta contigo; en los yates grandes un marinero sirve las bebidas y se ocupa de los juguetes acuáticos. El combustible de una ruta normal, el hielo, el agua y la hielera suelen estar incluidos; lee el anuncio, porque algunos cobran aparte el combustible o la limpieza.",
            "Los extras más comunes son jet skis, colchonetas flotantes, tablas de paddle o banana boat, a veces incluidos y a veces por hora. La comida y la bebida casi siempre las llevas tú (sin vidrio), o puedes pedir catering al reservar. La propina de la tripulación no está en el precio: lo habitual es un 15–20 %."
          ]
        },
        {
          "h": "Tamaño, invitados y duración",
          "p": [
            "El número de invitados define el barco. La mayoría de los yates privados de Miami llevan hasta 12 o 13 personas —el límite para un barco sin certificado de pasajeros de la Guardia Costera—, así que un yate de 37–50 pies sirve para una familia o un grupo de amigos, y uno de 60–70 pies da al mismo grupo más cubierta, sombra y camarotes. Para grupos más grandes hace falta un yate de fiesta inspeccionado, con licencia para decenas de invitados.",
            "Los alquileres suelen empezar en tres o cuatro horas, y muchos yates piden cuatro como mínimo los fines de semana. Con cuatro horas alcanza para el skyline, Star Island y un baño; con seis a ocho llegas a un fondeadero más tranquilo, almuerzas a bordo y vuelves al atardecer."
          ]
        },
        {
          "h": "Rutas y cuándo ir",
          "p": [
            "Las rutas clásicas salen de Miami Beach, el río Miami o Bayside, pasan por el puerto de cruceros, Fisher Island y las mansiones de Star Island y Millionaire's Row, y anclan en el sandbar de Haulover o de Nixon para bañarse. Los alquileres largos bajan más allá de Key Biscayne hasta Stiltsville, las casas de madera sobre pilotes del Parque Nacional Biscayne, o salen al océano frente a Miami Beach.",
            "De noviembre a abril la bahía está tranquila y el clima seco, y los fines de semana se llenan pronto, sobre todo en las fiestas y durante Art Basel. En verano, sal por la mañana: las tormentas de la tarde son frecuentes y los capitanes cambian o acortan la salida si hay rayos cerca. La mayoría de los anuncios ofrece otra fecha o el reembolso si el clima cancela."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Necesito licencia para alquilar un yate en Miami?",
          "a": "No si va con capitán: todos los yates de esta página llevan un capitán con licencia que lo maneja. Para manejar un barco tú mismo en Florida, quien nació el 1 de enero de 1988 o después necesita la Boating Safety Education ID o un certificado temporal, que las empresas de alquiler pueden ayudarte a sacar."
        },
        {
          "q": "¿Cuántas personas caben en un yate?",
          "a": "La mayoría de los yates privados de Miami llevan hasta 12 o 13 invitados. Para un grupo más grande necesitas un yate de pasajeros inspeccionado —un barco de fiesta con licencia de la Guardia Costera para más gente— o dos barcos que naveguen juntos."
        },
        {
          "q": "¿Por cuántas horas conviene alquilar un yate?",
          "a": "Lo más común son cuatro horas: alcanza para el skyline, Star Island y una parada en el sandbar. Muchos yates tienen un mínimo de tres o cuatro horas; reserva de seis a ocho para llegar a Stiltsville o pasar el día entero en el agua."
        },
        {
          "q": "¿Hay que dejar propina al capitán?",
          "a": "Sí. La propina casi nunca está incluida en el precio, y lo habitual es un 15–20 % del alquiler para el capitán y la tripulación, al final de la salida."
        }
      ]
    },
    "sandbar-boat-tours": {
      "title": "Tours al sandbar",
      "short": "Tours al\nsandbar",
      "intro": "Paseos en barco a los sandbars de Haulover y Nixon y a Raccoon Island: báñate y párate en el agua baja y clara de la bahía de Biscayne.",
      "seoTitle": "Tours en barco al sandbar de Miami: Haulover y Nixon",
      "heading": "Tours en barco al sandbar en Miami",
      "meta": "Tours en barco a los sandbars de Miami: el sandbar de Haulover y Raccoon Island en el norte de la bahía de Biscayne, el sandbar de Nixon frente a Key Biscayne, salidas privadas y guiadas.",
      "partnerTitle": "Tu propio barco al sandbar",
      "partnerText": "Sailo tiene barcos y yates privados en la zona de Sunny Isles Beach, cerca del sandbar de Haulover. Elige el barco por tamaño e invitados, confirma con el propietario que la ruta incluye el sandbar y reserva en su sitio.",
      "guideTitle": "Los sandbars de Miami: lo que hay que saber",
      "guide": [
        {
          "h": "¿Haulover o Nixon?",
          "p": [
            "El sandbar de Haulover está justo dentro de Haulover Inlet, en el norte de la bahía de Biscayne, entre Bal Harbour y Sunny Isles Beach. Es el más concurrido de Miami: los barcos anclan uno al lado del otro en agua clara que llega a la cintura, y los fines de semana se convierte en una fiesta flotante con música y tablas de paddle. Raccoon Island, al lado, es más tranquila, con un paseo corto por la isla y aves.",
            "El sandbar de Nixon está frente a Key Biscayne, del lado de la bahía, y lleva el nombre del presidente que tuvo una casa allí. Es más amplio y suele estar más tranquilo que Haulover, con vista al skyline. Las salidas suelen partir del río Miami, Bayside o Key Biscayne."
          ]
        },
        {
          "h": "Cuándo ir",
          "p": [
            "Los sandbars están en su mejor momento cerca de la marea baja en un día tranquilo y soleado, cuando el agua es más baja y clara; con marea alta puede llegarte al pecho. Revisa la marea al reservar una salida de mañana o de tarde, y pregunta al capitán cuál recomienda.",
            "Entre semana el ambiente es relajado; sábados y domingos hay mucha gente y ruido, y el fin de semana de la regata de Columbus Day, en octubre, es la mayor fiesta de la bahía. En verano las tormentas de la tarde llegan rápido, así que la mañana es más segura, y los capitanes regresan en cuanto hay rayos cerca."
          ]
        },
        {
          "h": "Cómo llegar y las reglas",
          "p": [
            "A los sandbars solo se llega en barco. Si no tienes uno, súmate a una salida guiada o alquila un barco privado con capitán para tu grupo: desde Haulover Park, Sunny Isles Beach o Miami Beach, el sandbar de Haulover queda a minutos.",
            "En un barco con capitán los pasajeros pueden beber, pero lleva latas o plástico en vez de vidrio y vuelve con toda la basura. La policía y los agentes de vida silvestre de Florida patrullan los fines de semana, también contra los alquileres ilegales, así que reserva con un operador con licencia. Usa zapatos de agua para la arena y las algas, y protector solar apto para arrecifes."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Se puede llegar caminando o nadando al sandbar de Haulover?",
          "a": "No. El sandbar está en la bahía frente a Haulover Inlet, rodeado de canales profundos y tráfico de barcos, así que solo se llega en barco: un tour al sandbar, un barco privado con capitán o uno propio."
        },
        {
          "q": "¿Qué tan profunda es el agua en el sandbar?",
          "a": "Cerca de la marea baja llega del tobillo a la cintura en casi todo el sandbar, así que puedes pararte y caminar. Con marea alta es más profunda, y los bordes caen a canales, por lo que los niños deben usar chaleco salvavidas."
        },
        {
          "q": "¿Se puede tomar alcohol en los sandbars de Miami?",
          "a": "Los pasajeros pueden beber en un barco con capitán; quien maneja, no. Lleva latas o plástico, porque el vidrio está prohibido en la mayoría de los barcos, y espera controles de la policía los fines de semana concurridos."
        },
        {
          "q": "¿Qué sandbar es mejor para ir con niños?",
          "a": "Ve a cualquiera de los dos un día de semana por la mañana, o elige las salidas a Nixon o a Raccoon Island, que son más tranquilas. Haulover el fin de semana es una fiesta, con música alta y multitudes."
        }
      ]
    },
    "helicopter-tours": {
      "title": "Tours en helicóptero",
      "short": "Tours en\nhelicóptero",
      "intro": "Vuelos privados en helicóptero y avioneta sobre Miami Beach, la bahía de Biscayne y el skyline, de día, al atardecer o de noche.",
      "seoTitle": "Tours en helicóptero en Miami y vuelos panorámicos",
      "heading": "Tours en helicóptero en Miami",
      "meta": "Tours en helicóptero en Miami: vuelos privados sobre Miami Beach, Star Island y el skyline de Downtown, vuelos al atardecer con champán y paseos en avioneta.",
      "guideTitle": "Cómo elegir un tour en helicóptero en Miami",
      "guide": [
        {
          "h": "Rutas y duración",
          "p": [
            "La mayoría de los vuelos sigue la costa y la bahía: sube por Miami Beach y Ocean Drive, pasa sobre Star Island, Fisher Island y el puerto de cruceros, y rodea las torres de Downtown y Brickell. Las rutas largas siguen al norte hasta el hotel Hard Rock con forma de guitarra, en Hollywood, o salen sobre el océano. Los vuelos duran de unos 20 minutos a una hora; el anuncio indica el tiempo en el aire, sin contar la charla previa.",
            "Los vuelos al atardecer son los más pedidos, con el cielo naranja detrás del skyline, y los nocturnos muestran la ciudad iluminada. Por la mañana el aire suele estar más claro y tranquilo, ideal para fotos y para quien teme las turbulencias."
          ]
        },
        {
          "h": "¿Helicóptero o avioneta?",
          "p": [
            "El helicóptero vuela más bajo y más lento, puede girar y quedarse sobre los lugares, y tiene ventanas grandes y curvas; la mayoría de los privados lleva dos o tres pasajeros. Una avioneta hace una ruta parecida más rápido y más alto, normalmente por menos, y muchas tienen el ala sobre la cabina para que no tape la vista.",
            "En un vuelo privado la aeronave es solo para tu grupo y el precio es por vuelo, no por persona. El champán al aterrizar, las fotos y una ruta fija son extras habituales: lee qué incluye el anuncio."
          ]
        },
        {
          "h": "Antes de volar",
          "p": [
            "Los vuelos salen de aeropuertos pequeños fuera del centro, no de Miami Beach, así que revisa el punto de salida y calcula de 30 a 45 minutos en auto. Lleva una identificación con foto; al reservar también te piden el peso de cada pasajero, porque los asientos se asignan para equilibrar la aeronave y hay límites de peso.",
            "Las nubes bajas, las tormentas y el viento fuerte cancelan los vuelos, sobre todo en las tardes de verano; entonces el operador ofrece otro horario o el reembolso. Usa ropa oscura para evitar reflejos en las ventanas y deja gorras y bolsos sueltos en el auto."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Cuánto cuesta un tour en helicóptero en Miami?",
          "a": "Depende de la duración y de si el vuelo es privado o compartido: el privado se cobra por toda la aeronave, así que sale más barato por persona con dos o tres pasajeros. Las tarjetas de arriba muestran el precio actual de cada operador."
        },
        {
          "q": "¿Cuánto dura un tour en helicóptero en Miami?",
          "a": "Desde unos 20 minutos para una vuelta corta por la playa y el skyline hasta una hora para las rutas que llegan a Hollywood o salen sobre el océano. Suma una hora para la charla previa y el traslado al aeropuerto."
        },
        {
          "q": "¿Vale la pena volar al atardecer?",
          "a": "Es el horario más reservado, por los colores sobre el skyline y la bahía de Biscayne. Reserva con unos días de anticipación, porque hay pocos turnos al atardecer, y deja algo de margen por si el clima mueve el vuelo."
        },
        {
          "q": "¿Hay límite de peso en los tours en helicóptero?",
          "a": "Sí. Al reservar te piden el peso de cada pasajero para equilibrar la aeronave, y hay un límite por asiento; el límite exacto está en el anuncio o en la confirmación del operador."
        }
      ]
    },
    "everglades": {
      "title": "Everglades e hidrodeslizadores",
      "short": "Everglades",
      "intro": "Paseos en hidrodeslizador entre la hierba, caimanes y fauna salvaje: tours a los Everglades, a una hora de Miami.",
      "seoTitle": "Tours a los Everglades desde Miami: hidrodeslizador y fauna",
      "heading": "Tours en hidrodeslizador por los Everglades desde Miami",
      "meta": "Tours a los Everglades desde Miami: paseos en hidrodeslizador privados y semiprivados, caimanes y shows de fauna, medio día con recogida en el hotel y el parque nacional.",
      "guideTitle": "Cómo elegir un tour a los Everglades",
      "guide": [
        {
          "h": "¿Paseo en hidrodeslizador o un día en el parque?",
          "p": [
            "La mayoría de los tours a los Everglades son paseos en hidrodeslizador (airboat): una barca plana empujada por una gran hélice que se desliza sobre la hierba y el agua poco profunda del «río de hierba», con paradas para buscar caimanes, tortugas y garzas. El paseo dura de 30 a 90 minutos, y muchos parques de la Tamiami Trail añaden un show con caimanes y serpientes.",
            "Los hidrodeslizadores no están permitidos en la mayor parte del Parque Nacional Everglades, así que navegan en sus bordes y en las áreas protegidas de alrededor. Para conocer el parque, elige un tour que añada una caminata guiada, el tranvía de Shark Valley o una ruta en bici eléctrica; estos ocupan medio día o el día entero desde Miami."
          ]
        },
        {
          "h": "Compartido, semiprivado o privado",
          "p": [
            "Los hidrodeslizadores grandes llevan unas decenas de pasajeros y son la opción más barata, a menudo con autobús desde Miami. Los semiprivados y de grupo reducido suben a seis o diez personas en una barca más pequeña, que entra por canales más estrechos. Uno privado es solo para tu grupo, y el capitán para donde haya algo que ver.",
            "Si vas en coche, reserva el paseo en el propio parque: está a unos 40 minutos o una hora del centro de Miami. Sin coche, elige un tour con recogida; la ficha indica si incluye transporte y desde dónde."
          ]
        },
        {
          "h": "Cuándo ir y qué esperar",
          "p": [
            "La temporada seca, de diciembre a abril, es la mejor para ver fauna: los animales se concentran alrededor del agua que queda y hay menos mosquitos. En verano el pantano está más verde y lleno, pero hace calor y hay tormentas por la tarde, así que mejor un paseo por la mañana. Los caimanes se ven todo el año.",
            "Los hidrodeslizadores hacen mucho ruido (te dan protectores para los oídos) y van al sol: lleva una gorra que no se vuele, protector solar y repelente de insectos. La mayoría de los paseos admiten niños, pero revisa la edad mínima en la página del tour."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Cuánto dura un tour en hidrodeslizador por los Everglades?",
          "a": "El paseo en sí dura de 30 a 90 minutos. Con el transporte desde Miami y un show de fauna, calcula de cuatro a seis horas; los tours que incluyen el parque nacional ocupan el día entero."
        },
        {
          "q": "¿Veré caimanes?",
          "a": "Es muy probable. Los caimanes viven en los Everglades todo el año y los capitanes saben dónde buscarlos, sobre todo en la temporada seca, de diciembre a abril. Muchos parques tienen además un show de caimanes, así que verás uno de cerca en cualquier caso."
        },
        {
          "q": "¿Es un tour a los Everglades adecuado para niños?",
          "a": "Sí, la mayoría de los paseos en hidrodeslizador admiten niños y los shows de fauna les encantan. Algunos barcos no aceptan bebés por el ruido: revisa la edad mínima en la página del tour."
        },
        {
          "q": "¿Puedo combinar los Everglades con un tour por Miami?",
          "a": "Sí: los tours combinados suman un crucero por la bahía de Biscayne y un recorrido en autobús por Miami al paseo en hidrodeslizador en un solo día. Convienen si tienes poco tiempo, aunque las paradas son más cortas que en tours por separado."
        }
      ]
    },
    "city-tours": {
      "title": "Tours por la ciudad y art déco",
      "short": "Ciudad y\nart déco",
      "intro": "El distrito art déco de South Beach, Little Havana, los murales de Wynwood y Coconut Grove: Miami a pie, en bici o en autobús.",
      "seoTitle": "Tours por Miami: 3 en 1, a pie y en carrito de golf",
      "heading": "Tours por la ciudad de Miami",
      "meta": "Tours por Miami: recorridos 3 en 1 por South Beach, Wynwood y Little Havana, tours privados con chofer-guía, paseos a pie y en carrito de golf y un autobús descubierto.",
      "guideTitle": "Cómo elegir un tour por Miami",
      "guide": [
        {
          "h": "Tres barrios en un solo tour",
          "p": [
            "Miami es extensa, así que la mayoría de los visitantes la conocen con un tour «3 en 1»: South Beach con sus hoteles art déco y Ocean Drive, los murales de Wynwood y la Calle Ocho de Little Havana, en minibús o autobús descubierto en tres o cuatro horas. Es la forma más barata de ubicarse el primer día, con paradas cortas para fotos y un cafecito cubano.",
            "Para conocer bien una zona, elige un tour que se centre en ella: un recorrido a pie por el distrito art déco con un guía de arquitectura, un paseo en carrito de golf, buggy o Segway por el arte urbano de Wynwood, o una ruta de comida y cultura por Little Havana."
          ]
        },
        {
          "h": "A pie, en carrito de golf o en autobús",
          "p": [
            "Los tours a pie son los más detallados y suelen durar de dos a dos horas y media; los premiados tours art déco suman el neón de Ocean Drive al anochecer. Los carritos de golf y los buggies recorren las manzanas de Wynwood en una hora sin pasar calor, y son buena opción con niños o para quien no quiere caminar mucho. Los autobuses descubiertos muestran más ciudad de una vez: Brickell, Downtown, Coconut Grove.",
            "También hay tours por lugares de rodaje de cine y televisión, una ruta autoguiada en bici eléctrica por Coral Gables y tours privados con chofer-guía que adapta el recorrido a ti."
          ]
        },
        {
          "h": "Consejos para el día",
          "p": [
            "Empieza temprano o tarde: Miami es caluroso y húmedo casi todo el año, y el mediodía es el peor momento para caminar. Usa calzado cómodo y lleva agua y protector solar. Los tours nocturnos por Wynwood y South Beach muestran el neón y los murales iluminados.",
            "Revisa el punto de encuentro: los tours salen de Miami Beach, Wynwood o Downtown, y solo algunos incluyen recogida en el hotel. La lista está ordenada por reseñas, así que primero aparecen los tours con mejores valoraciones constantes."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Cuál es el mejor tour por Miami?",
          "a": "Para una primera visita, un tour 3 en 1 por South Beach, Wynwood y Little Havana cubre lo esencial en medio día. Para profundizar, los viajeros valoran más el tour a pie art déco de Miami Beach y el tour de arte urbano en carrito de golf por Wynwood."
        },
        {
          "q": "¿Cuánto dura un tour por Miami?",
          "a": "Los tours en carrito de golf y Segway por Wynwood duran de una a una hora y media, los tours a pie de dos a dos horas y media, y los recorridos completos en autobús de tres a cuatro horas."
        },
        {
          "q": "¿Los tours incluyen recogida en el hotel?",
          "a": "Algunos sí, sobre todo los de autobús y los privados; los tours a pie y en carrito de golf suelen quedar en un punto del barrio. La página del tour lo indica."
        },
        {
          "q": "¿Hay tours por la ciudad en español?",
          "a": "Sí, muchos guías de Miami hablan español y bastantes tours se ofrecen en los dos idiomas. Cada tour indica sus idiomas en el sitio del socio."
        }
      ]
    },
    "day-trips": {
      "title": "Key West y excursiones de un día",
      "short": "Key West y\nexcursiones",
      "intro": "Un día por la Overseas Highway hasta Key West, o a los Everglades, Fort Lauderdale y los Cayos de Florida.",
      "seoTitle": "Excursiones desde Miami: Key West y el Centro Espacial Kennedy",
      "heading": "Excursiones de un día desde Miami a Key West y más",
      "meta": "Excursiones de un día desde Miami: Key West por los Cayos de Florida y el Seven Mile Bridge, el Centro Espacial Kennedy, Palm Beach y Fort Lauderdale, en grupo o privadas.",
      "guideTitle": "Cómo elegir una excursión desde Miami",
      "guide": [
        {
          "h": "Key West y los Cayos de Florida",
          "p": [
            "La excursión clásica recorre la Overseas Highway, que salta de isla en isla sobre el mar: Key Largo, Islamorada, el Seven Mile Bridge y, al final, Key West, a unas 160 millas de Miami. Son unas cuatro horas por trayecto, así que los tours salen hacia las 6 o 7 de la mañana y vuelven tarde por la noche, con tres o cuatro horas en la isla: el Southernmost Point, la calle Duval, la casa de Hemingway y, en los tours más largos, el atardecer en Mallory Square.",
            "Las furgonetas de grupo reducido, de hasta unas 14 personas, paran en los Cayos para fotos y desayuno; los tours privados con chofer te dejan elegir las paradas y el ritmo."
          ]
        },
        {
          "h": "Hacia el norte: el Centro Espacial, Palm Beach y Fort Lauderdale",
          "p": [
            "El Centro Espacial Kennedy, en Cabo Cañaveral, está a unas tres horas y media al norte, así que la excursión dura unas 12 horas; el complejo de visitantes tiene el Saturno V y el transbordador Atlantis, y si hay un lanzamiento programado quizá lo veas. Palm Beach, a hora y media, es un día más tranquilo: las mansiones de la isla, el Museo Flagler y el hotel The Breakers, a menudo combinado con los canales y la playa de Fort Lauderdale.",
            "Para los Everglades, a menos de una hora y de medio día, mira la página de los Everglades."
          ]
        },
        {
          "h": "¿En grupo o privada?",
          "p": [
            "Los tours en grupo reducido son la opción más barata e incluyen el transporte y el guía; las entradas, las comidas y las actividades en Key West o en el Centro Espacial suelen ser aparte, así que compara qué incluye cada uno. Los privados cuestan bastante más, pero el precio es por todo el coche o SUV, así que para una familia o un grupo de amigos resultan razonables.",
            "Ponte ropa cómoda para muchas horas de coche, lleva algo de comer y el traje de baño si el tour para en una playa, y confirma el punto y la hora de recogida el día anterior."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Vale la pena una excursión de un día de Miami a Key West?",
          "a": "Si no puedes quedarte a dormir, sí: el viaje por los Cayos es parte de la experiencia. Pero es un día largo, de unas 12 horas con ocho en el coche; con más tiempo, pasar una noche en Key West es más relajado."
        },
        {
          "q": "¿A qué distancia está Key West de Miami?",
          "a": "A unas 160 millas, unas cuatro horas por la Overseas Highway sin paradas. Los tours tardan más porque paran en los Cayos por el camino."
        },
        {
          "q": "¿Se puede visitar el Centro Espacial Kennedy desde Miami en un día?",
          "a": "Sí, los tours desde Miami duran unas 12 horas: unas tres horas y media por trayecto y de cinco a seis horas en el complejo de visitantes. Revisa si la entrada está incluida."
        },
        {
          "q": "¿Qué incluye una excursión de un día?",
          "a": "El transporte y el chofer o guía siempre están incluidos; las entradas, las comidas y las actividades cambian según el tour. Cada página indica qué incluye y qué no."
        }
      ]
    },
    "water-sports": {
      "title": "Deportes acuáticos",
      "short": "Deportes\nacuáticos",
      "intro": "Motos acuáticas en la bahía de Biscayne, paddle surf, esnórquel y parasailing frente a Miami Beach.",
      "seoTitle": "Deportes acuáticos en Miami: motos acuáticas, banana y más",
      "heading": "Deportes acuáticos en Miami",
      "meta": "Deportes acuáticos en Miami: tours guiados en moto acuática por la bahía de Biscayne, yates con motos acuáticas, banana y tubing, wakesurf, esquí acuático y jet cars.",
      "guideTitle": "Cómo elegir deportes acuáticos en Miami",
      "guide": [
        {
          "h": "Tours en moto acuática por la bahía de Biscayne",
          "p": [
            "La moto acuática (jet ski) es el deporte acuático favorito de Miami. En un tour guiado sigues a un guía por la bahía durante una hora más o menos, frente a los rascacielos, Star Island y las casas de los famosos, con paradas para fotos; en la mayoría van una o dos personas por moto. El alquiler en una zona delimitada junto a la marina es más corto y barato, pero no sales de esa zona.",
            "La ley de Florida fija una edad mínima para manejar una moto acuática, y quien haya nacido a partir del 1 de enero de 1988 necesita un certificado de seguridad náutica: la empresa de alquiler te da uno temporal antes de salir. Lleva un documento con foto y cuenta con un depósito reembolsable."
          ]
        },
        {
          "h": "Yates con juguetes, banana y jet cars",
          "p": [
            "Para un grupo, un yate que incluye una o dos motos acuáticas, banana o tubing combina el paseo con tiempo en los juguetes; algunos party boats incluyen barra libre. También hay salidas de wakesurf detrás de un barco especial, clases de esquí acuático para principiantes y jet cars, pequeñas lanchas con forma de deportivo que manejas tú.",
            "Algunos tours combinan la moto acuática con un paseo en cuatrimoto o a caballo en tierra para medio día de actividades."
          ]
        },
        {
          "h": "Cargos, clima y seguridad",
          "p": [
            "Revisa el precio total antes de reservar: el combustible, el traslado en barco a la zona de motos, los chalecos y los impuestos pueden estar incluidos o cobrarse el mismo día, y las ofertas con «todos los cargos incluidos» son más fáciles de comparar. La propina al guía es habitual.",
            "Por la mañana el agua está más tranquila. Las tormentas de la tarde en verano pueden suspender las actividades con poco aviso, y la mayoría de las empresas ofrecen entonces otro horario o el reembolso. Ve en traje de baño, lleva gafas de sol con cordón y deja los objetos de valor en tierra."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Cuánto cuesta un tour en moto acuática en Miami?",
          "a": "Un tour guiado de una hora cuesta aproximadamente entre $85 y $190 por moto, según la empresa y los cargos incluidos. Los yates con motos acuáticas tienen precio por grupo."
        },
        {
          "q": "¿Necesito licencia para manejar una moto acuática en Miami?",
          "a": "Licencia no, pero quien haya nacido a partir del 1 de enero de 1988 necesita un certificado de seguridad náutica de Florida; las empresas de alquiler dan uno temporal en el momento tras un breve examen. También hay una edad mínima para manejar: revísala en la página del tour."
        },
        {
          "q": "¿Pueden ir dos personas en una moto acuática?",
          "a": "Sí, la mayoría admiten dos personas, y algunos tours cobran por moto y no por persona, así que ir en pareja sale más barato."
        },
        {
          "q": "¿Son los deportes acuáticos aptos para niños?",
          "a": "Los niños suelen poder ir de pasajeros con un adulto, y la banana y el tubing gustan mucho a los mayores. Las edades mínimas cambian según la actividad y la empresa; cada página del tour las indica."
        }
      ]
    },
    "attractions": {
      "title": "Atracciones y entradas",
      "short": "Atracciones\ny entradas",
      "intro": "Entradas para museos, jardines, zoológicos y parques de Miami: Vizcaya, el Museo Frost, Zoo Miami y más.",
      "seoTitle": "Entradas para atracciones de Miami: museos, zoo y Vizcaya",
      "heading": "Atracciones y entradas en Miami",
      "meta": "Entradas para atracciones de Miami: Vizcaya, Superblue, PAMM, Frost Science, Zoo Miami, Jungle Island, el Paradox Museum, Wynwood Walls y pases Go City.",
      "guideTitle": "Cómo elegir atracciones en Miami",
      "guide": [
        {
          "h": "Arte, museos y jardines",
          "p": [
            "Los museos de Miami se agrupan en unas pocas zonas. En Wynwood, los Wynwood Walls muestran murales de artistas de todo el mundo, con entrada por horario y visitas guiadas, y el Museum of Graffiti cuenta la historia del arte urbano. En el centro, el Pérez Art Museum Miami (PAMM) y el museo Frost Science, con su acuario y su planetario, comparten Museum Park frente a la bahía, a pocos pasos de la Freedom Tower.",
            "Vizcaya, una villa de estilo italiano de la década de 1910 con jardines frente a la bahía en Coconut Grove, es la visita más elegante de Miami; el Deering Estate, más al sur, combina una casa histórica con senderos en la naturaleza. Superblue ofrece arte inmersivo de luz y sonido, y el Paradox Museum y el Museum of Ice Cream son paradas divertidas y muy fotogénicas."
          ]
        },
        {
          "h": "Animales y días en familia",
          "p": [
            "Zoo Miami, en el sur del condado, es un gran zoológico al aire libre al que hay que dedicar medio día, y un tranvía o una bici ayudan con el calor. Jungle Island, en Watson Island, entre Downtown y Miami Beach, tiene aves, encuentros con animales y shows. Para un día completo en familia, mira la página de actividades en familia."
          ]
        },
        {
          "h": "Entradas y pases",
          "p": [
            "La entrada en línea evita colas y, en los Wynwood Walls, Superblue y el Museum of Ice Cream, te asegura un horario: los fines de semana y en temporada alta se agotan. Un pase Go City reúne varias atracciones y tours por un solo precio; compensa si piensas visitar tres o más de su lista en pocos días.",
            "Cuenta con los traslados entre zonas: del centro a Vizcaya hay unos 15 minutos en coche, a Zoo Miami unos 40. La lista está ordenada por reseñas."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Qué atracciones no hay que perderse en Miami?",
          "a": "Las favoritas de los viajeros son los Wynwood Walls, el Museo y Jardines Vizcaya, el PAMM y Frost Science en Museum Park, y el distrito art déco de South Beach, que se puede ver gratis o con un tour guiado."
        },
        {
          "q": "¿Hay que reservar con antelación las entradas a los Wynwood Walls?",
          "a": "Es recomendable: la entrada es por franja horaria y las tardes del fin de semana se llenan. Con la entrada reservada en línea pasas directamente a tu hora."
        },
        {
          "q": "¿Vale la pena el pase Go City Miami?",
          "a": "Ahorra dinero si visitas al menos tres de las atracciones y tours que incluye dentro de su validez. Haz primero un plan y compáralo con el precio de las entradas por separado."
        },
        {
          "q": "¿Qué atracciones de Miami son a cubierto para un día de lluvia?",
          "a": "Frost Science, el PAMM, Superblue, el Paradox Museum, el Museum of Ice Cream y el Museum of Graffiti son a cubierto y buenas opciones para una tormenta de tarde en verano."
        }
      ]
    },
    "family": {
      "title": "Actividades en familia",
      "short": "En familia\ncon niños",
      "intro": "Qué hacer en Miami con niños: fauna, paseos tranquilos en barco, acuarios y parques para todas las edades.",
      "seoTitle": "Qué hacer en Miami con niños: zoo, ciencia y más",
      "heading": "Actividades en familia en Miami",
      "meta": "Qué hacer en Miami con niños: Zoo Miami, Jungle Island, el museo Frost Science con su acuario, el Museum of Ice Cream y pases de atracciones para familias.",
      "guideTitle": "Cómo organizar un día en familia en Miami",
      "guide": [
        {
          "h": "Animales y ciencia",
          "p": [
            "Zoo Miami es el gran día de excursión: un enorme zoológico al aire libre en el sur del condado, con animales de Asia, África y América en hábitats amplios. Requiere cuatro horas o más, así que llega a la hora de apertura para evitar el calor. Jungle Island, en Watson Island, es más pequeño y está más cerca de las playas, con loros, lémures, encuentros con animales y shows.",
            "El museo Frost Science, en el centro, sirve para todas las edades y con cualquier clima: un acuario de tres niveles con tiburones y rayas, un planetario y exposiciones interactivas sobre el cuerpo humano y el vuelo. El Museum of Ice Cream es una parada dulce y divertida para los más pequeños, con su piscina de chispas de colores y muchas degustaciones."
          ]
        },
        {
          "h": "Más allá de las entradas",
          "p": [
            "Muchos planes de otras categorías también funcionan con niños. Un paseo en hidrodeslizador por los Everglades con show de caimanes encanta a los niños en edad escolar, un crucero por la bahía de Biscayne es una hora fácil en el agua, y los tours en carrito de golf por Wynwood muestran los murales sin caminar mucho.",
            "Si piensas visitar varias atracciones, el Go City Explorer Pass te deja elegir de dos a cinco por un solo precio."
          ]
        },
        {
          "h": "Consejos para familias",
          "p": [
            "Deja las visitas al aire libre para la mañana y las de interior para la tarde, cuando el calor aprieta y llegan las tormentas de verano. Las entradas infantiles suelen ser más baratas y los más pequeños a menudo entran gratis: revisa los límites de edad en cada entrada. Lleva agua, protector solar, gorras y un cochecito para el zoo."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Qué hacer en Miami con niños pequeños?",
          "a": "Jungle Island, el acuario de Frost Science y el Museum of Ice Cream son lo más cómodo con niños pequeños: visitas cortas, sombra o aire acondicionado, y mucho que tocar y ver."
        },
        {
          "q": "¿Cuánto tiempo se necesita en Zoo Miami?",
          "a": "Calcula de cuatro a seis horas: el zoo es grande y caminar entre las zonas lleva tiempo. Un tranvía o unas bicis alquiladas lo hacen más fácil con niños."
        },
        {
          "q": "¿Es el museo Frost Science bueno para niños?",
          "a": "Sí: el acuario, el planetario y las exposiciones interactivas entretienen a niños de todas las edades durante dos o tres horas, y es un buen plan para un día de lluvia o de mucho calor."
        },
        {
          "q": "¿Las entradas infantiles son más baratas?",
          "a": "Normalmente sí, y los niños pequeños a menudo entran gratis. Los límites de edad cambian según la atracción y se indican en la página de cada entrada."
        }
      ]
    },
    "date-night": {
      "title": "Noche en pareja",
      "intro": "Cruceros al atardecer, cenas con vistas y planes para dos en Miami.",
      "seoTitle": "Planes románticos en Miami: cruceros al atardecer y vuelos",
      "heading": "Noche en pareja en Miami",
      "meta": "Planes románticos en Miami: cruceros al atardecer con champán por la bahía de Biscayne, yates privados para dos y vuelos al atardecer sobre Miami Beach.",
      "guideTitle": "Cómo planear una noche romántica en Miami",
      "guide": [
        {
          "h": "El atardecer en el agua",
          "p": [
            "El plan romántico más sencillo de Miami es un crucero al atardecer: una o dos horas por la bahía de Biscayne mientras el cielo se pone naranja detrás de las torres de Brickell, con una copa de champán. Los cruceros compartidos con champán desde Bayside son económicos y relajados; un barco privado para dos, con capitán y una botella en hielo, es la versión más íntima y puede parar en el rincón más tranquilo de la bahía.",
            "Calcula bien la hora: el sol se pone hacia las 5:30–6 de la tarde en invierno y después de las 8 en verano, y la mayoría de los tours ajustan la salida del atardecer a la temporada."
          ]
        },
        {
          "h": "Miami desde el aire",
          "p": [
            "Un vuelo privado en helicóptero o avioneta sobre Miami Beach, las islas y los rascacielos es la cita difícil de olvidar. Los vuelos duran de 30 a 60 minutos, muchos incluyen champán al aterrizar, y los vuelos al atardecer y de noche muestran la ciudad iluminada. La avioneta cuesta menos que el helicóptero para una ruta parecida.",
            "Los vuelos despegan de aeropuertos fuera del centro, así que cuenta con el trayecto, y suele haber un límite de peso por pasajero. Rutas y duración: mira Tours en helicóptero."
          ]
        },
        {
          "h": "Consejos para la noche",
          "p": [
            "Reserva con unos días de antelación para viernes y sábados, y deja el final de la noche libre para cenar en Brickell, Wynwood o South Beach. Las tormentas de verano pueden retrasar un crucero o un vuelo al atardecer; la mayoría de los tours ofrecen otra fecha o el reembolso."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Qué es lo más romántico que se puede hacer en Miami?",
          "a": "Un crucero privado al atardecer por la bahía de Biscayne con champán, o un vuelo en helicóptero al atardecer sobre Miami Beach, son las experiencias mejor valoradas por las parejas."
        },
        {
          "q": "¿Cuánto cuesta un crucero al atardecer para dos en Miami?",
          "a": "Un crucero compartido con champán cuesta entre $25 y $95 por persona aproximadamente. Un barco privado para dos con capitán empieza en unos $200–250 por dos horas."
        },
        {
          "q": "¿A qué hora es el atardecer en Miami?",
          "a": "Hacia las 5:30–6 de la tarde en diciembre y enero y hacia las 8:15 de la noche en junio y julio. Los tours fijan la salida del atardecer según la temporada."
        },
        {
          "q": "¿Puedo pedir matrimonio en un barco o un vuelo privado?",
          "a": "Sí, muchos capitanes y pilotos están acostumbrados: dilo al reservar y pregunta por flores, decoración o fotógrafo, que algunos tours ofrecen como extra."
        }
      ]
    },
    "beach-days": {
      "title": "Días de playa",
      "intro": "Miami Beach, Key Biscayne y los mejores días de arena y mar.",
      "seoTitle": "Días de playa en Miami: playas y paradas para nadar",
      "heading": "Días de playa en Miami",
      "meta": "Planea un día de playa en Miami: South Beach, Key Biscayne y Haulover, baños en islas en barco y tours que suman las playas de Fort Lauderdale.",
      "guideTitle": "Cómo pasar un día de playa en Miami",
      "guide": [
        {
          "h": "Qué playa para qué día",
          "p": [
            "South Beach es la famosa: arena ancha, casetas de socorristas y Ocean Drive detrás, con cafés y duchas a pocos pasos. Para un agua más tranquila y baja, ve a Key Biscayne —Crandon Park, con sombra y zonas de picnic, y Bill Baggs, con su faro— o al norte, a Haulover Park y Sunny Isles, más tranquilas entre semana.",
            "Algunos tours en furgoneta combinan las playas de Miami con Fort Lauderdale o Palm Beach para un día por la costa. Si no quieres manejar, South Beach es la más fácil de alcanzar en autobús o en Uber."
          ]
        },
        {
          "h": "Una parada para nadar en barco",
          "p": [
            "La otra forma de pasar un día de playa es en la bahía: un paseo en barco con baño frente a una pequeña isla o en un sandbar, donde el agua es clara, cálida y baja. Los tours a Raccoon Island suman un paseo corto por la isla con aves; un barco privado deja a tu grupo quedarse lo que quiera. Los sandbars en sí —Haulover y Nixon, mareas y fines de semana— tienen su propia página: Tours al sandbar."
          ]
        },
        {
          "h": "Sol, banderas y algas",
          "p": [
            "El sol de Florida es fuerte todo el año: lleva protector solar apto para arrecifes, gorra y mucha agua, y busca sombra a mediodía. En las playas públicas, báñate cerca de una caseta de socorristas y mira el color de la bandera por las corrientes.",
            "De la primavera al final del verano, a veces llega a las playas el sargazo; los sandbars de la bahía suelen verse menos afectados. Las salidas en barco se cambian de fecha o se reembolsan si las tormentas las cancelan."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Las playas de Miami son gratis?",
          "a": "Sí, las playas públicas de Miami y Miami Beach son gratis. Pagas el estacionamiento, y las sillas y sombrillas donde se alquilan; Crandon Park y Bill Baggs, en Key Biscayne, cobran entrada o estacionamiento por auto."
        },
        {
          "q": "¿Qué playa de Miami es mejor para familias?",
          "a": "Crandon Park, en Key Biscayne, tiene agua tranquila y poco profunda, sombra y servicios. South Beach tiene más ambiente, y Haulover Park y Sunny Isles, al norte, son más tranquilas."
        },
        {
          "q": "¿Se puede nadar en un paseo en barco en Miami?",
          "a": "Sí, la mayoría de los barcos privados y de las salidas a sandbars o islas incluyen paradas para nadar. Los cruceros panorámicos compartidos desde Bayside no."
        },
        {
          "q": "¿Cuál es la mejor época para un día de playa en Miami?",
          "a": "El agua está agradable casi todo el año. De noviembre a abril el clima es seco y agradable; el verano es más caluroso y con tormentas por la tarde, así que mejor ir por la mañana."
        }
      ]
    },
    "luxury": {
      "title": "Experiencias de lujo",
      "intro": "Yates privados, hidroaviones y tours exclusivos: Miami en su versión más exclusiva.",
      "seoTitle": "Lujo en Miami: yates privados, vuelos y tours VIP",
      "heading": "Experiencias de lujo en Miami",
      "meta": "Experiencias de lujo en Miami: yates privados con tripulación, cruceros con champán, vuelos panorámicos privados, rallies en autos exóticos y tours VIP por la ciudad.",
      "guideTitle": "Cómo elegir una experiencia de lujo en Miami",
      "guide": [
        {
          "h": "Desde el aire",
          "p": [
            "Los vuelos privados en helicóptero y avioneta sobre Miami Beach, las islas de la bahía de Biscayne y el skyline son el gran capricho de Miami, sobre todo al atardecer y con champán. Rutas, duración y qué revisar antes de volar: en la página Tours en helicóptero."
          ]
        },
        {
          "h": "En el agua y en la carretera",
          "p": [
            "Un yate privado con tripulación es la forma clásica de pasar una tarde en Miami con estilo: comida y bebidas a bordo, un baño en un sandbar y las casas de famosos de Star Island, con motos acuáticas en los barcos más grandes. Hay alternativas más tranquilas, como una lancha eléctrica por el río Miami con vino y embutidos, o un crucero al atardecer con champán.",
            "En tierra, los tours privados de día completo combinan la ciudad y un barco con un guía dedicado, un tour en furgoneta de lujo recorre playas y barrios, y el rally de coches exóticos lleva superdeportivos hasta Key West y de vuelta en 24 horas."
          ]
        },
        {
          "h": "Antes de reservar",
          "p": [
            "En yates y vuelos, el precio es por la experiencia privada, no por persona; revisa qué incluye —bebidas, catering, la propina de la tripulación, traslados— y los límites de pasajeros, incluido el peso en los helicópteros. Reserva con una semana o más de antelación para los fines de semana, Art Basel en diciembre y las fiestas."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Qué experiencias de lujo hay además de yates y vuelos?",
          "a": "Un rally en autos exóticos que va a Key West y vuelve en 24 horas, tours privados de día completo que combinan la ciudad y un barco con tu propio guía, un tour en van de lujo por playas y barrios, y un barco eléctrico por el río Miami con vino y embutidos."
        },
        {
          "q": "¿Cuál es la forma más lujosa de conocer Miami?",
          "a": "Un yate privado con tripulación por la bahía de Biscayne y, después, un vuelo en helicóptero al atardecer sobre Miami Beach: es la combinación que eligen muchos visitantes."
        },
        {
          "q": "¿Las bebidas están incluidas en los cruceros de lujo?",
          "a": "En los cruceros con champán, sí, va en el precio; en los yates privados depende del alquiler: algunos incluyen barra libre y otros te dejan llevar tus bebidas. Revisa la página del tour."
        },
        {
          "q": "¿Hay que reservar con antelación las experiencias de lujo?",
          "a": "Sí, sobre todo los fines de semana y en temporada alta, de diciembre a abril: los yates privados y los helicópteros tienen pocos horarios y los mejores se agotan primero."
        }
      ]
    },
    "art-and-culture": {
      "title": "Arte y cultura",
      "intro": "El arte urbano de Wynwood, la arquitectura art déco, Little Havana y los museos de Miami.",
      "seoTitle": "Arte y cultura en Miami: museos, galerías e historia",
      "heading": "Arte y cultura en Miami",
      "meta": "Arte y cultura en Miami: museos y galerías, el Design District, tours de arquitectura e historia, la herencia cubana y el arte urbano de la ciudad.",
      "guideTitle": "Descubrir el arte y la cultura de Miami",
      "guide": [
        {
          "h": "Arte urbano y diseño",
          "p": [
            "Wynwood es el corazón del arte en Miami: antiguos almacenes cubiertos de murales alrededor de los Wynwood Walls, galerías, cervecerías y cafés. Los tours van a pie, en carrito de golf o buggy, en Segway o con un artista urbano como guía, y algunos combinan los murales con degustaciones o un taller de grafiti. Al lado, el Design District mezcla boutiques de lujo con arte público y arquitectura, y Little River es el barrio creativo más reciente.",
            "Art Basel Miami Beach, a principios de diciembre, convierte toda la ciudad en una feria de arte, con decenas de ferias satélite y murales nuevos: la semana más concurrida y más cara del año."
          ]
        },
        {
          "h": "Art déco y el Miami cubano",
          "p": [
            "South Beach tiene uno de los mayores conjuntos de edificios art déco del mundo: hoteles en tonos pastel de los años treinta con letreros de neón, ventanas de ojo de buey y suelos de terrazo. Los paseos guiados explican el estilo y la batalla que lo salvó de la demolición, y el museo Wolfsonian muestra el diseño de la época.",
            "En Little Havana, la Calle Ocho es el centro del Miami cubano: una fábrica de tabacos donde se enrollan a mano, el Parque del Dominó, el cafecito de ventanita y música en vivo. Los tours de comida y cultura prueban los clásicos, del sándwich cubano a los pastelitos de guayaba."
          ]
        },
        {
          "h": "Museos",
          "p": [
            "Para el arte a cubierto, el PAMM frente a la bahía muestra arte moderno y contemporáneo, Superblue tiene instalaciones inmersivas, Vizcaya une una villa histórica con sus jardines y la Freedom Tower cuenta la historia del exilio cubano. Muchos tours de esta lista se ofrecen también en español o en francés."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Es gratis visitar Wynwood?",
          "a": "Las calles y la mayoría de los murales se pueden recorrer gratis. Los Wynwood Walls, el jardín central de murales, requieren una entrada con horario; los tours guiados explican los artistas y el barrio."
        },
        {
          "q": "¿Cuál es el mejor tour art déco de Miami Beach?",
          "a": "Los premiados tours a pie art déco, incluida una versión nocturna con el neón, son los mejor valorados; los tours privados con un guía de arquitectura entran en más detalle."
        },
        {
          "q": "¿Qué se puede hacer en Little Havana?",
          "a": "Pasear por la Calle Ocho, ver a los jugadores de dominó, visitar una fábrica de tabacos, tomar un cafecito y probar la comida cubana; un tour de degustación con guía local lo cubre en dos o tres horas."
        },
        {
          "q": "¿Cuándo es Art Basel Miami Beach?",
          "a": "A principios de diciembre de cada año. Los hoteles y los tours se agotan y los precios suben, así que planifica con tiempo si vas en esas fechas."
        }
      ]
    },
    "south-beach": {
      "title": "South Beach",
      "intro": "Ocean Drive, el distrito art déco y la playa: qué hacer en South Beach.",
      "seoTitle": "Qué hacer en South Beach: tours art déco y más",
      "heading": "Qué hacer en South Beach, Miami Beach",
      "meta": "Qué hacer en South Beach: tours a pie art déco por Ocean Drive, tours nocturnos de neón, Lincoln Road y Española Way, el Wolfsonian y salidas en barco desde South Beach.",
      "guideTitle": "Descubrir South Beach",
      "guide": [
        {
          "h": "El distrito art déco",
          "p": [
            "South Beach, el extremo sur de Miami Beach, gira en torno a su distrito art déco: cientos de hoteles y edificios de apartamentos en tonos pastel de los años veinte a los cuarenta a lo largo de Ocean Drive, Collins Avenue y Washington Avenue, con franjas horizontales, ventanas de ojo de buey y neón. Un tour guiado a pie, que sale cerca del Art Deco Welcome Center de Ocean Drive, explica cómo nació el estilo y cómo el distrito se salvó de la demolición en los años setenta y ochenta.",
            "Los tours nocturnos muestran el neón encendido, algunos se hacen en francés o en bici, y el museo Wolfsonian añade las artes decorativas de la época."
          ]
        },
        {
          "h": "Más allá de Ocean Drive",
          "p": [
            "Lincoln Road es la calle peatonal de tiendas y cafés, y Española Way, con sus arcos de estilo mediterráneo, está llena de restaurantes. La playa es ancha y gratuita, con las famosas casetas de socorristas de colores; desde South Pointe Park, en la punta, se ven salir los cruceros por Government Cut.",
            "Varios tours por la ciudad combinan South Beach con Wynwood y Little Havana en medio día, y algunas salidas en velero parten de las marinas de South Beach."
          ]
        },
        {
          "h": "Consejos",
          "p": [
            "Pasea por la mañana o a última hora de la tarde para evitar el calor del mediodía, y vuelve a Ocean Drive de noche para ver el neón. El estacionamiento es caro: un VTC o el trolley gratuito de Miami Beach son más cómodos."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Por qué es famosa South Beach?",
          "a": "Por su arquitectura art déco, la playa con sus casetas de socorristas de colores, la vida nocturna de Ocean Drive y Washington Avenue y las tiendas de Lincoln Road."
        },
        {
          "q": "¿Cuánto dura un tour a pie art déco?",
          "a": "Normalmente de dos a dos horas y media, por Ocean Drive y las calles de detrás. También hay tours más cortos con lo esencial y tours privados."
        },
        {
          "q": "¿South Beach es lo mismo que Miami Beach?",
          "a": "South Beach es la parte sur de Miami Beach, una ciudad aparte situada en una isla barrera al otro lado de la bahía de Biscayne. Allí está la mayor parte del distrito art déco."
        },
        {
          "q": "¿Se puede recorrer South Beach a pie?",
          "a": "Sí: el distrito art déco, Lincoln Road y Española Way están a menos de 20 minutos a pie entre sí, y un trolley gratuito recorre Miami Beach."
        }
      ]
    },
    "wynwood": {
      "title": "Wynwood",
      "intro": "Arte urbano, galerías y cervecerías: qué hacer en Wynwood.",
      "seoTitle": "Qué hacer en Wynwood: tours de arte urbano y Wynwood Walls",
      "heading": "Qué hacer en Wynwood, Miami",
      "meta": "Qué hacer en Wynwood: tours de arte urbano en carrito de golf, buggy y Segway, entradas a los Wynwood Walls, tours de comida y arte, cervecerías y el Design District.",
      "guideTitle": "Descubrir Wynwood",
      "guide": [
        {
          "h": "Los murales y los Wynwood Walls",
          "p": [
            "Wynwood, un antiguo barrio de almacenes justo al norte del centro, es una de las mayores galerías de arte urbano al aire libre del mundo: cientos de murales cubren sus paredes y cada año aparecen nuevos, sobre todo en torno a Art Basel en diciembre. En su centro, los Wynwood Walls son un jardín de murales de artistas de todo el mundo con entrada, que se puede visitar con entrada directa, acceso temprano o fuera de horario, o con un taller de grafiti."
          ]
        },
        {
          "h": "Cómo recorrerlo",
          "p": [
            "Los carritos de golf y los buggies son la forma más popular de ver Wynwood: una hora por sus manzanas con un guía que conoce a los artistas, a la sombra del techo. Los tours en Segway recorren unas cuatro millas, y los tours a pie van más despacio y más a fondo; algunos los guía un artista urbano o se hacen en francés. De noche, el tour en carrito de golf muestra los murales iluminados.",
            "Los tours de comida y arte suman degustaciones en los restaurantes de Wynwood, y un tour de cervecerías para en sus cervecerías artesanales. Al lado, el Design District tiene arte público, arquitectura y boutiques de diseño, y Little River es el barrio creativo más al norte."
          ]
        },
        {
          "h": "Consejos",
          "p": [
            "Visítalo por la mañana o al atardecer mejor que a mediodía, y lleva calzado cómodo. Reserva los Wynwood Walls con antelación para los fines de semana."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Cuánto tiempo se necesita en Wynwood?",
          "a": "Un tour guiado en carrito de golf dura una hora; con los Wynwood Walls, una comida y un paseo, calcula medio día."
        },
        {
          "q": "¿Hace falta entrada para Wynwood?",
          "a": "El barrio se recorre gratis, pero los Wynwood Walls requieren una entrada con horario."
        },
        {
          "q": "¿Es seguro visitar Wynwood?",
          "a": "Las calles centrales alrededor de los Wynwood Walls tienen mucha gente de día y por la tarde y se visitan sin problema; como en cualquier ciudad, de noche quédate en las calles principales y vigila tus cosas."
        },
        {
          "q": "¿Cuál es la mejor forma de ver los murales de Wynwood?",
          "a": "Los viajeros valoran más el tour en carrito de golf en grupo reducido: recorre los murales principales en una hora con un guía que explica a los artistas, sin caminar con calor."
        }
      ]
    },
    "little-havana": {
      "title": "Little Havana",
      "intro": "La Calle Ocho, comida cubana, tabacos y partidas de dominó: qué hacer en Little Havana.",
      "seoTitle": "Qué hacer en Little Havana: tours de comida y tabacos",
      "heading": "Qué hacer en Little Havana, Miami",
      "meta": "Qué hacer en Little Havana: tours de comida y cultura por la Calle Ocho, una fábrica de tabacos, cafecito cubano y el Parque del Dominó, y tours que incluyen Little Havana.",
      "guideTitle": "Descubrir Little Havana",
      "guide": [
        {
          "h": "La Calle Ocho",
          "p": [
            "Little Havana, al oeste del centro, creció con los exiliados cubanos que llegaron a partir de los años sesenta, y la Calle Ocho —SW 8th Street— es su calle principal. En pocas cuadras están el Parque del Dominó, donde los mayores juegan bajo los árboles, el Tower Theater, las estrellas del Paseo de la Fama de artistas latinos, puestos de fruta, galerías de arte y ventanitas que sirven tacitas de café cubano bien dulce."
          ]
        },
        {
          "h": "Comida, tabacos y música",
          "p": [
            "Un tour de degustación es la mejor forma de conocerla: dos o tres horas con un guía local probando el sándwich cubano, croquetas, empanadas, pastelitos de guayaba y jugos naturales, mientras escuchas la historia del barrio. Un tour por una fábrica de tabacos muestra cómo se enrollan a mano, y por la noche los bares de la Calle Ocho tienen música cubana en vivo y salsa.",
            "El último viernes de cada mes, los Viernes Culturales convierten la Calle Ocho en una fiesta en la calle con música y arte."
          ]
        },
        {
          "h": "Combinarla con otras zonas",
          "p": [
            "Little Havana es una parada habitual de los tours de medio día que también recorren South Beach y Wynwood, y algunos tours más largos la combinan con los Everglades. Un tour gastronómico dedicado te da mucho más tiempo en la Calle Ocho."
          ]
        }
      ],
      "faq": [
        {
          "q": "¿Por qué es famosa Little Havana?",
          "a": "Por la cultura cubana: la Calle Ocho, el Parque del Dominó, los tabacos enrollados a mano, el café y la comida cubanos y la música latina en vivo."
        },
        {
          "q": "¿Cuánto tiempo dedicar a Little Havana?",
          "a": "Dos o tres horas bastan para recorrer la Calle Ocho con un café y una comida; un tour gastronómico guiado aprovecha bien ese tiempo."
        },
        {
          "q": "¿Hace falta hablar español en Little Havana?",
          "a": "No, en tiendas y restaurantes se habla inglés, aunque el español es el idioma de la calle, y los guías de muchos tours hablan los dos."
        },
        {
          "q": "¿Cuándo son los Viernes Culturales?",
          "a": "El último viernes de cada mes, por la tarde-noche, a lo largo de la Calle Ocho, con música en vivo, arte y puestos de comida."
        }
      ]
    },
    "brickell": {
      "title": "Brickell y Downtown",
      "intro": "Los rascacielos, Bayside y la bahía: qué hacer en Brickell y el centro de Miami."
    },
    "seeAlso": "Ver también:",
    "faqTitle": "Preguntas frecuentes"
  },
  "partners": {
    "title": "¿Quieres más barcos para elegir?",
    "text": "Sailo es un portal de alquiler de barcos con cientos de barcos y yates privados en Miami, desde lanchas pequeñas hasta yates grandes con tripulación. Los precios, la disponibilidad y la reserva están en su sitio.",
    "button": "Ver barcos"
  },
  "empty": {
    "title": "Muy pronto",
    "text": "Estamos sumando los primeros socios para esta lista. Mientras tanto, aquí tienes algunas ideas para empezar."
  },
  "card": {
    "tour": "Tours y experiencias",
    "boat": "Yates y cruceros",
    "from": "desde {{price}}",
    "reviews_one": "{{count}} opinión",
    "reviews_other": "{{count}} opiniones"
  },
  "footer": {
    "sisterSites": "Nuestras otras guías:",
    "about": "Tours, paseos en barco, hidrodeslizadores en los Everglades y qué hacer en todo Miami.",
    "thingsToDo": "Qué hacer",
    "areas": "Barrios",
    "language": "Idioma",
    "disclosure": "© miami-todo.com · Una guía independiente. Algunos enlaces son de afiliados: si reservas a través de nuestros socios, podemos recibir una comisión sin coste adicional para ti.",
    "tours": "Tours y excursiones"
  },
  "notFound": {
    "title": "Página no encontrada",
    "text": "La página que buscas no existe o se ha movido.",
    "home": "Ir a Miami To-Do"
  },
  "sample": {
    "dinner": {
      "category": "Noche en pareja",
      "title": "Cena con vistas",
      "text": "Veladas junto al agua con vistas inolvidables de Miami.",
      "place": "Brickell",
      "alt": "Terraza de un restaurante frente a los rascacielos de Miami al atardecer"
    },
    "beach": {
      "category": "Días de playa",
      "title": "Días en Miami Beach",
      "text": "Sol, mar y las torres de socorrista de South Beach.",
      "place": "Miami Beach",
      "alt": "Torre de socorrista en Miami Beach con los hoteles detrás"
    },
    "yacht": {
      "category": "Yates y cruceros",
      "title": "Yate privado",
      "text": "Navega por la costa de Miami con total comodidad.",
      "place": "Bahía de Biscayne",
      "alt": "Yate navegando frente a los rascacielos de Miami"
    }
  },
  "stub": {
    "saved": {
      "title": "Guardados",
      "intro": "Guarda en un solo lugar las experiencias que te gustan.",
      "text": "Muy pronto podrás guardar experiencias. Mientras tanto, aquí tienes algunas ideas para empezar."
    },
    "account": {
      "title": "Cuenta",
      "intro": "Tu cuenta de Miami To-Do.",
      "text": "Las cuentas llegarán muy pronto. Mientras tanto, aquí tienes algunas ideas para empezar."
    }
  },
  "tours": {
    "searchLabel": "Buscar tours",
    "searchPlaceholder": "Airboat, crucero al atardecer, Key West…",
    "resultsFor": "Resultados para «{{query}}»",
    "noResults": "No hay resultados para «{{query}}».",
    "clearSearch": "Borrar búsqueda",
    "showMore_one": "Ver {{count}} más",
    "showMore_other": "Ver {{count}} más"
  },
  "detail": {
    "book": "Reservar",
    "via": "vía {{partner}}",
    "delisted": "Esta experiencia ya no está disponible.",
    "duration": "Duración",
    "rating": "Valoración",
    "price": "Precio",
    "more": "Más experiencias"
  },
  "tourFacts": {
    "includedTitle": "Qué incluye",
    "included": "Incluido",
    "excluded": "No incluido",
    "meetingTitle": "Punto de encuentro y recogida",
    "knowBeforeTitle": "Antes de ir",
    "private": "Tour privado: solo participa tu grupo",
    "shared_one": "Tour compartido, hasta {{count}} viajero",
    "shared_other": "Tour compartido, hasta {{count}} viajeros",
    "languages": "Idiomas del guía: {{languages}}",
    "pickupOptions": {
      "PICKUP_EVERYONE": "Recogida incluida para todos los viajeros",
      "PICKUP_AND_MEET_AT_START_POINT": "Recogida opcional o encuentro en el punto de partida",
      "MEET_EVERYONE_AT_START_POINT": "Encuentro en el punto de partida (sin recogida)"
    }
  }
}
